import 'keen-slider/keen-slider.min.css';

import { useKeenSlider } from 'keen-slider/react';
import Image from 'next/image';
import AnchorArrow from 'react-scale/components/elements/anchor-arrow';
import Tabs from 'react-scale/components/elements/tabs';

const Events = ({ tabs }) => (
  <Tabs
    tabs={tabs.map(tab => ({
      content: <Event tab={tab} />,
      title: tab.title
    }))}
  />
);

export default Events;

const Event = ({ tab }) => {
  const [sliderRef] = useKeenSlider({
    loop: false,
    centered: true,
    slides: {
      perView: 1,
      spacing: 16
    },
    mode: 'snap'
  });

  return (
    <>
      <div className="w-screen sm:hidden left-1/2 relative transform px-7 -translate-x-1/2 overflow-hidden">
        <div ref={sliderRef} className="keen-slider w-full !overflow-visible">
          {tab.events.map((event, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className="keen-slider__slide flex flex-col bg-neutral-900 rounded-lg overflow-hidden"
            >
              <picture className="inline-block relative sm:flex-1 w-full h-56">
                <Image
                  src={event.image.src}
                  alt={event.image.alt}
                  layout="fill"
                  objectFit="cover"
                  quality={100}
                />
              </picture>

              <div className="flex flex-col flex-1 py-6 px-4">
                <p className="text-scale-lightskyblue mb-4">{event.overtitle}</p>
                <h4 className="font-aeonik text-2xl leading-8 mb-4">{event.title}</h4>
                <p className="text-lg text-neutral-400 leading-[30px] font-medium mb-8">
                  {event.subtitle}
                </p>
                <span className="mt-auto text-lg">
                  <AnchorArrow text="Schedule a Demo" href={event.href} />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="xl:grid-cols-2 gap-y-20 gap-x-8 hidden sm:grid">
        {tab.events.map((event, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className="space-y-8 sm:space-y-0 flex flex-col sm:grid grid-cols-2 bg-neutral-900 rounded-lg overflow-hidden"
          >
            <picture className="inline-block relative sm:flex-1 w-full h-72 xl:h-80">
              <Image
                src={event.image.src}
                alt={event.image.alt}
                layout="fill"
                objectFit="cover"
                quality={100}
              />
            </picture>

            <div className="flex flex-col flex-1 py-6 px-8">
              <p className="text-scale-lightskyblue mb-4">{event.overtitle}</p>
              <h4 className="font-aeonik text-2xl leading-8 mb-4">{event.title}</h4>
              <p className="text-lg text-neutral-400 leading-[30px] font-medium">
                {event.subtitle}
              </p>
              <span className="mt-8 sm:mt-auto text-lg">
                <AnchorArrow text="Schedule a Demo" href={event.href} />
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
